var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMoonNightMode = function SvgMoonNightMode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.187 9.456a.333.333 0 0 1 .468.378 5.497 5.497 0 0 1-1.436 2.524 5.43 5.43 0 0 1-7.679.1 5.433 5.433 0 0 1 .101-7.68 5.49 5.49 0 0 1 2.511-1.433.34.34 0 0 1 .385.478 4.287 4.287 0 0 0 .793 4.845 4.284 4.284 0 0 0 4.857.788Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11.56 2.261a.502.502 0 0 1 .88 0l.39.711a.5.5 0 0 0 .198.199l.71.389a.502.502 0 0 1 0 .88l-.71.39a.5.5 0 0 0-.199.198l-.389.71a.502.502 0 0 1-.88 0l-.39-.71a.5.5 0 0 0-.198-.199l-.71-.389a.502.502 0 0 1 0-.88l.71-.39a.5.5 0 0 0 .199-.198l.389-.71Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgMoonNightMode;